
import { Vue, Component } from 'vue-property-decorator'
import * as tool from '@/utils/tool'
import { TeaConfig } from '@/const/dashboard'

@Component({
  name: 'Creative',
})
export default class Creative extends Vue {
  TeaConfig = TeaConfig;

  mounted() {
    this.$trackEvent('adp_waplite_impression', {
      'dashboard_campaign': 'dash_mobiletopc_bestpractice_creativepage',
    })
  }

  data() {
    return {
      bannerLeft: [
        { title: 'Video Template', desc: 'Add your photos to our pre-made animated templates'},
        { title: 'Smart Video', desc: 'Transform your assets into TikTok ready videos with one click'},
        { title: 'Smart Text', desc: 'Find the perfect caption to pair with your ad'},
      ],
      bannerRight: [
        { title: 'Smart Video Soundtrack', desc: 'Sync your video with the perfect background music'},
        { title: 'Music Library', desc: 'Access over 4000 copyright free songs'},
        { title: 'Quick Optimization', desc: 'Optimize any video for any placement'},
      ],
    }
  }

  copyURL() {
    tool.accessPC()
  }
}

